export const NOTIFICATIONS_STORAGE_KEY = 'naviex-notificacoes';

export type NotificationType = 'info' | 'success' | 'warning';

export interface AppNotification {
  id: string;
  toEmail: string;
  title: string;
  description: string;
  createdAt: string;
  type: NotificationType;
  readAt?: string;
  metadata?: Record<string, string | unknown>;
}

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

function getAllNotifications(): AppNotification[] {
  try {
    const raw = localStorage.getItem(NOTIFICATIONS_STORAGE_KEY);
    const parsed = raw ? (JSON.parse(raw) as AppNotification[]) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveAllNotifications(items: AppNotification[]): void {
  try {
    localStorage.setItem(NOTIFICATIONS_STORAGE_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
}

export function addNotification(input: Omit<AppNotification, 'id' | 'createdAt' | 'toEmail'> & { toEmail: string }): AppNotification {
  const next: AppNotification = {
    ...input,
    id: `notif-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
    toEmail: normalizeEmail(input.toEmail),
  };
  const all = getAllNotifications();
  all.unshift(next);
  saveAllNotifications(all);
  return next;
}

export function getNotificationsForEmail(email: string): AppNotification[] {
  const target = normalizeEmail(email);
  return getAllNotifications().filter((n) => normalizeEmail(n.toEmail) === target);
}

export function markNotificationAsRead(id: string): void {
  const all = getAllNotifications();
  const idx = all.findIndex((n) => n.id === id);
  if (idx < 0) return;
  if (!all[idx].readAt) {
    all[idx] = { ...all[idx], readAt: new Date().toISOString() };
    saveAllNotifications(all);
  }
}

export function removeNotification(id: string): void {
  const all = getAllNotifications();
  const next = all.filter((n) => n.id !== id);
  if (next.length !== all.length) saveAllNotifications(next);
}
